.button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: var(--space-2);
  min-width: 0;
  border: var(--border-width) solid transparent;
  border-radius: var(--radius-md);
  font-weight: var(--weight-medium);
  line-height: 1;
  text-decoration: none;
  white-space: nowrap;
  cursor: pointer;
  user-select: none;
  transition:
    background-color var(--duration-fast) var(--ease-standard),
    border-color var(--duration-fast) var(--ease-standard),
    color var(--duration-fast) var(--ease-standard),
    transform var(--duration-fast) var(--ease-standard);
}

.button:active:not(:disabled) {
  transform: scale(0.98);
}

.button:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

.label {
  overflow: hidden;
  text-overflow: ellipsis;
}

.spinner {
  font-size: var(--icon-sm);
}

.sm {
  height: var(--control-sm);
  padding: 0 var(--space-3);
  font-size: var(--text-sm);
}

.md {
  height: var(--control-md);
  padding: 0 var(--space-4);
  font-size: var(--text-md);
}

.lg {
  height: var(--control-lg);
  padding: 0 var(--space-6);
  font-size: var(--text-lg);
}

.fullWidth {
  width: 100%;
}

.primary {
  background: var(--color-accent);
  color: var(--color-on-accent);
}

.primary:hover:not(:disabled) {
  background: var(--color-accent-hover);
}

.primary:active:not(:disabled) {
  background: var(--color-accent-pressed);
}

/* Draws attention without competing with the screen's primary action. */
.tonal {
  background: var(--color-accent-soft);
  color: var(--color-accent-text);
}

.tonal:hover:not(:disabled) {
  background: color-mix(in srgb, var(--color-accent-soft) 80%, var(--color-accent) 20%);
}

.secondary {
  background: var(--color-surface-raised);
  border-color: var(--color-border-strong);
  color: var(--color-text);
}

.secondary:hover:not(:disabled) {
  background: var(--color-surface-hover);
}

.secondary:active:not(:disabled) {
  background: var(--color-surface-pressed);
}

.ghost {
  background: transparent;
  color: var(--color-text);
}

.ghost:hover:not(:disabled) {
  background: var(--color-surface-hover);
}

.ghost:active:not(:disabled) {
  background: var(--color-surface-pressed);
}

.danger {
  background: var(--color-danger);
  color: var(--color-on-danger);
}

.danger:hover:not(:disabled) {
  background: var(--color-danger-hover);
}
